import { z } from 'zod';

export const narrativeSectionKeySchema = z.enum([
  'cooking-up',
  'data-world',
  'website',
  'outstanding-needs',
  'feedback',
  'upcoming-meetings',
  'budget-current',
  'budget-target',
  'budget-increase',
  'budget-projected',
]);

export type NarrativeSectionKey = z.infer<typeof narrativeSectionKeySchema>;

export const narrativeBlockSchema = z.object({
  sectionKey: narrativeSectionKeySchema,
  richText: z.string().max(10_000),
  updatedAt: z.string().nullish(),
});

export type NarrativeBlock = z.infer<typeof narrativeBlockSchema>;
